/**
 * Shared property mixins for blocks.
 *
 * These interfaces are composed into block types via intersection.
 * Each mixin provides a focused set of properties for a specific concern.
 */

export {
	type SpatialProperties,
	type CoordinateSystem,
	DEFAULT_SPATIAL,
	DEFAULT_CANVAS_SPATIAL,
} from './Spatial'

export {
	type LayoutContainerProperties,
	type LayoutProperties,
	type LayoutMode,
	type LayoutAlign,
	DEFAULT_LAYOUT,
	DEFAULT_LAYOUT_PROPERTIES,
	DEFAULT_DOCUMENT_LAYOUT,
	DEFAULT_DOCUMENT_LAYOUT_PROPERTIES,
	DEFAULT_SLIDE_LAYOUT,
	DEFAULT_SLIDE_LAYOUT_PROPERTIES,
	DEFAULT_CANVAS_LAYOUT,
	DEFAULT_CANVAS_LAYOUT_PROPERTIES,
	DEFAULT_ROW_LAYOUT_PROPERTIES,
	DEFAULT_COLUMN_LAYOUT_PROPERTIES,
} from './Layout'

// OrganizationProperties and DEFAULT_ORGANIZATION have been DELETED.
// Organizational metadata is now stored in junction tables:
// - user_block_stars (starring)
// - playbook_trash (soft delete)
// - folder_contents (folder organization)
// - user_block_access (access tracking)
// - playbook_contents (playbook membership)
// See migration 032 for details.
